import AboutUsScreen from 'components/screens/about-us/about-us-screen'
import React from 'react'

export interface WhoWeAreRouteProps {}

const WhoWeAreRoute: React.FC<WhoWeAreRouteProps> = ({}) => {
  return <AboutUsScreen />
}

export default WhoWeAreRoute
